import Widget from 'components/widget';
import { Screen } from 'components/screen';

export class ScreenLink extends Widget {
  public static selector = 'a[data-screen-id]';
  protected screenID: string;

  constructor(screen: Screen, el: HTMLLinkElement) {
    super(screen, el);
    this.screenID = this.el.getAttribute('data-screen-id') as string;

    // Bind to click event.
    el.onclick = (e) => {
      this.onClick();
      return false;
    };
  }

  protected onClick() {
    // Render new screen.
    this.marinSSO.renderScreen(
      {
        container: this.screen.containerEl,
        screenID: this.screenID,
      },
      this.screen.context
    );
  }
}

export default ScreenLink;
